export enum DocumentTypes {
    ISPS = 'ISPS',
    ZI = 'ZI',
    IK = 'IK',
    NPTN = 'NPTN',
    BWR = 'BWR',
    DEKLOT = 'DEKLOT',
    DEKLOT_TRUCK = 'DEKLOT_KAMION',
    DEKLOT_WAGON = 'DEKLOT_VAGON',
    IMPOS = 'IMPOS',
    PPBO = 'PPBO',
    VAR = 'VAR',
    FAL2D = 'FAL2D',
    FAl2O = 'FAL2O',
    RASPR = 'RASPR',

    OST = 'OST',
    FAL3D = 'FAL3D',
    FAL3O = 'FAL3O',

    FAL5D = 'FAL5D',
    FAL5O = 'FAL5O',

    FAL6D = 'FAL6D',
    FAL6O = 'FAL6O',

    FAL7D = 'FAL7D',
    FAL7O = 'FAL7O',
    FAL7L = 'FAL7L',
    BUNKER_ODL = 'BUNKER_ODL',
    BUNKER_DOL = 'BUNKER_DOL',
    PELJ_D = 'PELJ_D',
    PELJ_O = 'PELJ_O',
    NTRT = 'NTRT',

    OTP = 'OTP',
    OTP_IZUZ = 'OTP_IZUZ',
    OTP_NAC = 'OTP_NAC',
    OTP_NEXT = 'OTP_NEXT',
    OTP_UGO = 'OTP_UGO',
    OTP_ISP = 'OTP_ISP',

    SMNO_JANAF = 'SMNO_JANAF',
    BROB_SIKL = 'BROB_SIKL',
    KONTR_RAS = 'KONTR_RAS',
    KONTR_JANAF = 'KONTR_JANAF',
    KONTR_GOR = 'KONTR_GOR',
    SIO = 'SIO',
    ZAH_OA = 'ZAH_OA',
    DEKLOT_BUNKGOR = 'DEKLOT_BUNK/GOR',
    DOS = 'DOS'
}
